import CyesaOrderItemConfig from '../cyesa/order-item'
import DefaultOrderItemRowConfig from '../default/order-item'
import webshopName from '../common/webshop-name'

const orderItemModuleConfig = webshopName === 'cyesa-com' ? CyesaOrderItemConfig : DefaultOrderItemRowConfig

export default orderItemModuleConfig
